import http from "./http";

export const GetMyCards = async (params) =>
  await http.get("/cards/me", {params});
